import type { ICellRendererParams } from 'ag-grid-community'
import type { ReactElement } from 'react'

import LazyLoadedImage from '~/components/LazyLoadedImage'

import './styles.scss'

const ScreenshotsCellRenderer = ({ value }: ICellRendererParams<unknown, string[]>): ReactElement => {
  if (!value) return <div />

  return (
    <div className="cluster-screenshots-cell-renderer">
      <div className="cluster-screenshots-cell-renderer__content">
        {value.map((el, idx) => (
          <LazyLoadedImage
            alt={`preview ${idx + 1}`}
            className="screenshot"
            height={250}
            key={idx}
            src={el}
            width={138}
          />
        ))}
      </div>
    </div>
  )
}

export default ScreenshotsCellRenderer
